module.exports = __webpack_public_path__ + "static/media/bg-title.de76fb6f.jpg";